<template>
  <div class="maindiv index-wrap bg-gray index_main">
<!--    <custome/>-->
    <div v-if="loading" class="loader cont pt55" style="min-height: 480px" >
      <div class="loader-inner ball-pulse ct">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-else>
    <banner ref="banner" :banners="infos.banner" :filevideo = "infos.filevideo"></banner>
    </div>
    <div class="newsdiv htmldiv mt20">
      <div class="notices wd370 ht400 bgw pl15 pr20 pt20 dinline-block br5 vtop">
        <div class="st bborder pb5">
          <router-link to="/evn/list?id=0&pid=2" class="more fr tc6 br30 mt5 trans3">更多 +</router-link>
          <div class="dinline-block">
            <div class="sst fs24 mr5 dinline-block prelative">
              <span class="img-notice img-bg dinline-block vcenter"></span>
              校园新闻
            </div>
            <span class="farial tc9 tupper">Notice</span>
          </div>
        </div>
        <div v-if="loading" class="loader cont pt20" >
          <div class="loader-inner ball-pulse ct">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div v-else class="cont pt20">
          <template v-if="infos.notice">
            <div class="sdiv pl5 cpointer fs16 lh16 ofhidden prelative mb5 pl20 pr5" v-for="(info,index) in infos.schoolNews" v-if="index<8"
                 @click="$router.push(`/evn/detail?id=0&pid=2&article_id=${info.id}&num=${index}`)">
              {{info.title}}
            </div>
          </template>
        </div>
      </div>
<!--      <news v-if="infos.schoolNews" :items="infos.schoolNews" />-->
      <div class="notices wd500 ht400 bgw pl15 pr20 pt20 dinline-block br5 vtop ml10">
        <div class="st bborder pb5">
          <router-link to="/evn/list?id=0&pid=5" class="more fr tc6 br30 mt5 trans3">更多 +</router-link>
          <div class="dinline-block">
            <div class="sst fs24 mr5 dinline-block prelative">
              <span class="img-news img-bg dinline-block vcenter"></span>
              招生动态
            </div>
            <span class="farial tc9 tupper">News</span>
          </div>
        </div>
        <div v-if="loading" class="loader cont pt20" >
          <div class="loader-inner ball-pulse ct">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div v-else class="cont pt20">
          <template v-if="infos.schoolNews">
            <div v-for="(info,index) in infos.enrollment_news" v-if="index<8"
                 class="sdiv pl5 cpointer fs16 lh16 ofhidden prelative mb5 pl20 pr5"
                 @click="$router.push(`/evn/detail?id=0&pid=5&article_id=${info.id}&num=${index}`)">
              <!--                 @click="$router.push(`/enroll/article/detail?pid=3&category_id=7&article_id=${info.id}`)">-->
              {{info.title}}
            </div>
          </template>
        </div>
      </div>

      <div class="ens wd370 ht400 bgw pl15 pr20 pt20 fr br5 vtop">
        <div class="st bborder pb5">
          <router-link to="/evn/list?id=1&pid=2" class="more fr tc6 br30 mt5 trans3">更多 +</router-link>
          <div class="dinline-block">
            <div class="sst fs24 mr5 dinline-block prelative">
              <span class="img-ens img-bg dinline-block vcenter"></span>
              通知公告
            </div>
            <span class="farial tc9 tupper">Enroll</span>
          </div>
        </div>
        <div v-if="loading" class="loader cont pt20" >
          <div class="loader-inner ball-pulse ct">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div v-else class="cont pt20">
          <template v-if="infos.enrollment_news">
            <div class="sdiv pl5 cpointer fs16 lh16 ofhidden prelative mb5 pl20 pr5" v-for="(info,index) in infos.notice" v-if="index<8"
                 @click="$router.push(`/evn/detail?id=1&pid=2&article_id=${info.id}&num=${index}`)">
              {{info.title}}
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="sndiv htmldiv mt20">
      <div class="discs bgw pl15 pr20 pt20 dinline-block br5 vtop ht530">
        <div class="st bborder pb5">
          <router-link to="/disc?id=0&pid=0" class="more fr tc6 br30 mt5 trans3">更多 +</router-link>
          <div class="dinline-block">
            <div class="sst fs24 mr5 dinline-block prelative">
              <span class="img-dis img-bg dinline-block vcenter"></span>
              专业介绍
            </div>
            <span class="farial tc9 tupper">profession</span>
          </div>
        </div>
        <div v-if="loading" class="loader cont pt20" style="min-width: 1246px" >
          <div class="loader-inner ball-pulse ct">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div v-else class="cont pt25 pl5">
          <template v-if="infos.professionalIntroduction">
            <disc-item class="sdiv mb30 mb10 dinline-block cpointer br2" v-for="(info,index) in infos.professionalIntroduction" :key="info.id" :item="info">
            </disc-item>
          </template>
        </div>
      </div>
    </div>

<!--    <div class="sndiv htmldiv mt20">-->
<!--      <div class="discs bgw pl15 pr20 pt20 dinline-block br5 vtop">-->
<!--        <div class="st bborder pb5">-->
<!--          <router-link to="/disc?id=1&pid=0" class="more fr tc6 br30 mt5 trans3">更多 +</router-link>-->
<!--          <div class="dinline-block">-->
<!--            <div class="sst fs24 mr5 dinline-block prelative">-->
<!--              <span class="img-dis img-bg dinline-block vcenter"></span>-->
<!--              智能控制系-->
<!--            </div>-->
<!--            <span class="farial tc9 tupper">profession</span>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="cont pt25 pl5">-->
<!--          <template v-if="infos.professionalIntroduction_zn">-->
<!--            <disc-item class="sdiv mb30 mb10 dinline-block cpointer br2" v-for="(info,index) in infos.professionalIntroduction_zn" :key="info.id" :item="info">-->
<!--            </disc-item>-->
<!--          </template>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="sndiv htmldiv mt20">-->
<!--      <div class="discs bgw pl15 pr20 pt20 dinline-block br5 vtop">-->
<!--        <div class="st bborder pb5">-->
<!--          <router-link to="/disc?id=2&pid=0" class="more fr tc6 br30 mt5 trans3">更多 +</router-link>-->
<!--          <div class="dinline-block">-->
<!--            <div class="sst fs24 mr5 dinline-block prelative">-->
<!--              <span class="img-dis img-bg dinline-block vcenter"></span>-->
<!--              文创设计系-->
<!--            </div>-->
<!--            <span class="farial tc9 tupper">profession</span>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="cont pt25 pl5">-->
<!--          <template v-if="infos.professionalIntroduction_wc">-->
<!--            <disc-item class="sdiv mb30 mb10 dinline-block cpointer br2" v-for="(info,index) in infos.professionalIntroduction_wc" :key="info.id" :item="info">-->
<!--            </disc-item>-->
<!--          </template>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <div class="env htmldiv bgw pl15 pr20 pt20 pb10 br5 mt20 ht300" style="position: relative;" >
      <div class="st bborder pb5">
        <router-link to="/evn/list?id=3&pid=1" class="more fr tc6 br30 mt5 trans3">更多 +</router-link>
        <div class="dinline-block">
          <div class="sst fs24 mr5 dinline-block prelative">
            <span class="img-env img-bg dinline-block vcenter"></span>
            学校风光
          </div>
          <span class="farial tc9 tupper">scenery</span>
        </div>
      </div>
      <div v-if="loading" class="loader cont pt20" >
        <div class="loader-inner ball-pulse ct">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div v-else class="cont ofhidden pt30 pl5"  style="padding-left: 10px">
        <div v-if="infos.collegeScenery" class="sdiv fl two prelative cpointer mb30 ml5 mr30 ofhidden cont tleft "
               style="width:1200px;">
          <div class="cont tleft  pb20" id="viewer" >
            <div style="display: flex;" >
              <div style="margin-left: 20px" class="senv  mb25 ofhidden prelative cpointer dinline-block" v-for="(item,index) in infos.collegeScenery" :key="item.id" >
                <div class="fbg p100 pabsolute twhite tright trans3">
                  <div class="fs16 fbold mr25 mb5 mt20 ml20">{{item.title}}</div>
                  <div class="fs13 mr25 ml20" v-if="item.description>''">摄影：{{item.description}}</div>
                  <div class="pabsolute br50 bg-red tcenter">
                  </div>
                </div>
                <img class="img trans3" :src="item['picture'][0]" width="305" height="200" />
                <template v-for="(items,indexs) in item['picture']">
                  <img class="img trans3"   :src="items" width="305" height="200" v-if="indexs!=0"/>
                </template>
              </div>
            </div>
          </div>
        </div>
<!--        infos.collegeScenery.picture-->
        <div v-if="infos.collegeScenery" class="arrow" style="margin-left: -2.2%" @click="leftarrow(info-1)">
          <svg t="1678066880578" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3861" width="40" height="50"><path d="M161.1 511.2l373.6-373.6c26.4-26.4 61-39.5 95.6-39.5 34.6 0 69.2 13.2 95.6 39.5 52.7 52.7 52.7 138.5 0 191.2L400.4 654.3c-10.3 10.3-27 10.3-37.3 0-10.3-10.3-10.3-27 0-37.3l325.4-325.4c32.2-32.2 32.2-84.5 0-116.6-32.2-32.2-84.5-32.2-116.6 0L198.4 548.5M630.3 98.1" fill="#2197EF" p-id="3862"></path><path d="M371 375.9l341.2 341.2c42.5 42.5 42.5 111.4 0 153.9s-111.4 42.5-153.9 0L217 529.9" fill="#CEE8FA" p-id="3863"></path><path d="M198.4 548.5l336.3 336.3c25.5 25.5 59.5 39.6 95.6 39.6 36.1 0 70.1-14.1 95.6-39.6 52.7-52.7 52.7-138.5 0-191.2L389.6 357.3m-74.6 0l17.4 17.4 19.8 19.8 336.3 336.3c32.2 32.2 32.2 84.5 0 116.6-15.6 15.6-36.3 24.2-58.3 24.2s-42.7-8.6-58.3-24.2L235.7 511.2l-20.5-20.5-16.7-16.7" fill="#2197EF" p-id="3864"></path></svg>
        </div>
        <div v-if="infos.collegeScenery" class="arrow right-arr" @click="leftarrow(info+1)">
          <svg t="1678067020853" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6251" width="40" height="50"><path d="M836.8 551.2L462 176.4c-32.3-32.3-84.8-32.3-117 0-32.3 32.3-32.3 84.8 0 117L671.5 620c10.3 10.3 10.3 27.1 0 37.4-10.3 10.3-27.1 10.3-37.4 0L307.6 330.8c-52.9-52.9-52.9-139 0-191.8 26.4-26.4 61.2-39.7 95.9-39.7s69.5 13.2 95.9 39.7l374.8 374.8M403.5 99.3" fill="#2197EF" p-id="6252"></path><path d="M818.1 532.5L475.8 874.9c-42.6 42.6-111.8 42.6-154.4 0-42.7-42.6-42.7-111.8 0-154.4l342.4-342.4" fill="#CEE8FA" p-id="6253"></path><path d="M645 359.4L307.6 696.8c-52.9 52.9-52.9 139 0 191.8 25.6 25.6 59.7 39.7 95.9 39.7s70.3-14.1 95.9-39.7l337.4-337.4m0-74.8L820 493.2l-20.6 20.6L462 851.2c-15.6 15.6-36.4 24.2-58.5 24.2s-42.9-8.6-58.5-24.2c-32.3-32.3-32.3-84.8 0-117l337.4-337.4 19.9-19.9 17.5-17.5" fill="#2197EF" p-id="6254"></path></svg>
        </div>
      </div>
    </div>

    <div class="env htmldiv bgw pl15 pr20 pt20 pb10 br5 mt20 ht175">
      <div class="st bborder pb5">
<!--        <router-link to="/evn/list?id=7&pid=1" class="more fr tc6 br30 mt5 trans3">更多 +</router-link>-->
        <div class="dinline-block">
          <div class="sst fs24 mr5 dinline-block prelative">
            <span class="img-friend img-bg dinline-block vcenter"></span>
            友情链接
          </div>
          <span class="farial tc9 tupper">Links</span>
        </div>
      </div>
      <div v-if="loading" class="loader cont pt20" >
        <div class="loader-inner ball-pulse ct">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div v-else class="cont ofhidden pt30 pl5">
        <template v-if="infos.links" v-for="(info,index) in infos.links">
          <a target="_blank" :href="info.link" class="dinline-block vtop ofhidden mb15 tran3">
            <img :src="info['picture'][0]" alt="" width="165">
          </a>
        </template>
      </div>
    </div>

    <div class="ht25"></div>
<!--    <div v-if="showimg" style="width: 100vw;height: 100vh;background-color: rgba(0,0,0,0.5);position: fixed;top: 0;z-index: 9999">-->

<!--    </div>-->
  </div>
</template>

<script>
import Viewer from "../../../static/viewer/viewer.min.js";
import Start from '../../../static/viewer/start.js'

import Banner from '@/components/index/Banner'
import News from '@/components/index/News'
import NevItem from "@/components/index/NevItem";
import DiscItem from "@/components/index/DiscItem";
// import Custome from "../../components/Custome";
export default {
  name: "index",
  components: {
    Banner,
    News,
    NevItem,
    DiscItem,
    // Custome,
  },
  data(){
    return {
      infos:{},
      imgback:{
      },
      info:0,
      loading:false
    }
  },
  updated() {
    this.$nextTick(function(){
      var viewer = new Viewer(document.getElementById('viewer'), {
        url: 'src'
      });
      Start.start();
    })
  },
  created() {
    this.getData();
  },
  mounted() {
    $('.sns .tab').mouseover(function() {
      var key = $(this).data('key')
      $(this).addClass('sst').siblings('.tab').removeClass('sst')
      $('.sns .scont' + key).show().siblings('.scont').hide()
    })
  },
  methods:{
    showList(re){
      console.log(re)
    },
    leftarrow(res){
      let list = this.imgback.slice(res*4,res*4+4);
      console.log(res)
      if(res<0){
        console.log('最小值')
        this.info = 0;
        return
      }
      if(list.length==0){
        console.log(Math.ceil((this.imgback.length /4)))
        this.info = Math.ceil((this.imgback.length /4))-1
        return
      }else{
        this.info = res
        console.log('正常')
        this.infos['collegeScenery'] = list
      }
    },
    getData(){
      this.loading = true
      this.$request.get('home',[],response => {
        if(response.data.code == 200){
          this.infos = response.data.data
          this.imgback = response.data.data.collegeScenery;
          this.infos['collegeScenery'] = response.data.data.collegeScenery.slice(0,4);
          this.loading = false
        }
        console.log(this.infos)
      },error => {
        console.log(error)
      })
    },
  }
  // beforeRouteEnter(to, form, next) {
  //   this.$refs.banner.initBanner();
  //   next()
  // },
}
</script>
<style scoped>
.arrow{
  position: absolute;
  margin: 0 -0.6%;
  margin-top: 5%;
  z-index: 555;
}
.right-arr{
  right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue